import { render, staticRenderFns } from "./PopularPlace.vue?vue&type=template&id=6784957e&"
import script from "./PopularPlace.vue?vue&type=script&lang=js&"
export * from "./PopularPlace.vue?vue&type=script&lang=js&"
import style0 from "./PopularPlace.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PopularPlace.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VFlex,VImg,VRow})
